// extracted by mini-css-extract-plugin
export default {"divider":"HisDateDivider_divider__f7RZA"};